// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconUserAnalytics.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconUserAnalytics = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M10.5622 4.1509C10.5622 6.44353 8.74443 8.302 6.50199 8.302C4.25974 8.302 2.44178 6.44353 2.44178 4.1509C2.44178 1.85827 4.25955 0 6.50199 0C8.74443 0 10.5622 1.85827 10.5622 4.1509Z" />
    <path d="M6.50199 10.2303C6.67014 10.2303 6.83628 10.2216 7 10.2046V16H2.02755C0.909266 16 0.00265533 15.0731 0.00265533 13.9298V13.6188H0V13.2827H0.0110007C0.0117594 11.3085 1.16627 9.56209 2.78166 8.46726C3.67746 9.54464 5.01064 10.2303 6.50199 10.2303Z" />
    <path d="M11.0769 8H12.9231V16H11.0769V8Z" />
    <path d="M14.1538 12H16V16H14.1538V12Z" />
    <path d="M9.84615 10.5H8V16H9.84615V10.5Z" />
  </BaseIcon>
);

export default IconUserAnalytics;
